import Image from 'next/image'
import React, { useEffect, useRef, useState } from 'react'
import { VideoProps } from '~types'
import styles from './Video.module.scss'
import { useIsIntersecting } from 'utils/hooks/useIsIntersecting'
import { NEXT_IMAGE_QUALITY } from '~constants'

const VIDEO_PLAYBACK_MODE = {
  SUCCESS: 'success',
  FAILED: 'failed'
}

const Video = ({ autoPlay = true, backgroundVideo, posterImage, videoLoop, externalVideoRef, handlePlaybackFailed }: VideoProps) => {
  const backgroundVideoRef = externalVideoRef ? externalVideoRef : useRef<HTMLVideoElement>(null)
  const [videoPlaybackMode, setVideoPlaybackMode] = useState<string>('')
  const isElementIntersecting = useIsIntersecting({
    ref: backgroundVideoRef
  })
  const [videoPlayStatus, setVideoPlayStatus] = useState(false)

  useEffect(() => {
    if (backgroundVideo) {
      backgroundVideoRef.current?.load()
    }
  }, [backgroundVideo])

  const playVideo = () => {
    backgroundVideoRef.current
      ?.play()
      .then(() => {
        backgroundVideoRef.current.poster = ''
        setVideoPlaybackMode(VIDEO_PLAYBACK_MODE.SUCCESS)
        handlePlaybackFailed && handlePlaybackFailed(false)
      })
      .catch(() => {
        /* Automatic playback failed */
        setVideoPlaybackMode(VIDEO_PLAYBACK_MODE.FAILED)
        handlePlaybackFailed && handlePlaybackFailed(true)
      })
  }

  useEffect(() => {
    if (backgroundVideoRef && backgroundVideoRef.current) {
      if (isElementIntersecting) {
        setVideoPlayStatus(true)
        playVideo()
      } else if (!isElementIntersecting) {
        setVideoPlayStatus(false)
      }
    }
  }, [isElementIntersecting, backgroundVideoRef])

  useEffect(() => {
    if (videoPlayStatus) {
      playVideo()
    } else {
      backgroundVideoRef?.current?.pause()
    }
  }, [videoPlayStatus])

  const posterImgSrc = posterImage?.url || ''

  return (
    <div className={styles['full-screen-video-container']}>
      {videoPlaybackMode === VIDEO_PLAYBACK_MODE.FAILED ? (
        <div className={styles['poster-container']}>
          {posterImgSrc && <Image alt="Hero Video Poster" src={posterImgSrc} width="0" height="0" sizes="100vw" quality={NEXT_IMAGE_QUALITY} />}
        </div>
      ) : backgroundVideo?.url ? (
        <video autoPlay={autoPlay} loop={videoLoop} ref={backgroundVideoRef} muted playsInline={true} poster={posterImgSrc} disableRemotePlayback>
          <source src={backgroundVideo.url} type="video/mp4" />
        </video>
      ) : null}
    </div>
  )
}
export default Video
